import haversine from 'haversine';
import { useEffect } from 'react';
import { useQueueStore } from '../queues/context/use-queue-store';
import { useUnitLocationStore } from '../fr-unit-location/use-unit-location-store';
import { EventQueueStore } from './store/event-queue-store';

const DISTANCE_UPDATE_INTERVAL = 30_000; // ms
const MIN_DISTANCE_TO_TRIGGER_UPDATE = 100; // meters

export function useDistanceUpdater() {
    const queueStore = useQueueStore() as EventQueueStore;
    const unitLocationStore = useUnitLocationStore();

    const unitLocation = unitLocationStore?.unitLocation;
    const listItems = queueStore.listStore.data.list;
    const distanceFieldsGeneralCheckPass =
        listItems.length && listItems.some((e) => e.distanceFromEvent);

    useEffect(() => {
        const now = Date.now();
        const timePassed = now - queueStore.lastDistanceUpdateTime >= DISTANCE_UPDATE_INTERVAL;

        if (queueStore.lastDistanceUpdateLocation && unitLocation === undefined) {
            queueStore.updateDistancesForAllEvents(unitLocation);
            return;
        }

        if (!queueStore.lastDistanceUpdateLocation && unitLocation) {
            queueStore.updateDistancesForAllEvents(unitLocation);
            return;
        }

        if (queueStore.lastDistanceUpdateLocation && unitLocation && timePassed) {
            const distanceUnitMoved = haversine(
                queueStore.lastDistanceUpdateLocation,
                unitLocation,
                { unit: 'meter' }
            );

            if (distanceUnitMoved >= MIN_DISTANCE_TO_TRIGGER_UPDATE) {
                queueStore.updateDistancesForAllEvents(unitLocation);
            }
        }

        if (
            queueStore.lastDistanceUpdateLocation &&
            !distanceFieldsGeneralCheckPass &&
            unitLocation
        ) {
            queueStore.updateDistancesForAllEvents(unitLocation);
        }
    }, [distanceFieldsGeneralCheckPass, queueStore, unitLocation, unitLocationStore]);
}
